import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'passes',
    lazy: async () => ({ Component: (await import('./PassesPage')).PassesPage }),
  },
];
